/**
 * Определяет, является ли текущая среда выполнения серверной.
 *
 * @returns `true`, если код выполняется на сервере, `false` - в браузере
 */
export function isServer() {
    return typeof window === 'undefined';
}
